<template>
  <div class="ms-container">
    <payments-page type="contragent" />
  </div>
</template>

<script>
import PaymentsPage from '@/components/payments/payments-page'
export default {
  components: {
    PaymentsPage
  }
}
</script>

<style></style>
